export interface CodeWaitScreenProps {
  code: string;
}

/** Code path: huge 6-digit code (grouped 3+3) while waiting for the staff. */
export function CodeWaitScreen({ code }: CodeWaitScreenProps): JSX.Element {
  const grouped = `${code.slice(0, 3)} ${code.slice(3)}`;
  return (
    <div className="wait-screen">
      <span className="brand brand-dark">
        Fast<span className="brand-accent">garage</span>
      </span>
      <p className="wait-label">Ihr Code</p>
      <div className="wait-code" aria-label={`Code ${code}`}>
        {grouped}
      </div>
      <div className="wait-spinner" aria-hidden="true" />
      <p className="wait-text">
        Warten auf Verbindung — nennen Sie diesen Code Ihrem Werkstatt-Ansprechpartner am Telefon.
      </p>
      <p className="wait-subtext">
        Ihre Kamera ist bereits aktiv. Sobald sich die Werkstatt verbindet, startet die Übertragung.
      </p>
    </div>
  );
}
